import {Pipe, PipeTransform} from '@angular/core';

import {LocalisationService} from '../services/localisation.service';
import {Languages} from '../enums/languages';

@Pipe({
    name: 'money'
})

export class MoneyPipe implements PipeTransform {

    constructor(
        private readonly localisationService: LocalisationService
    ) {
    }

    transform(money: any): string {
        let currencySymbol = ' ' + this.localisationService.localise('currency');
        let position = 'right';

        if (this.localisationService.getLanguage() === Languages.English) {
            position = 'left';
            currencySymbol = '€';
        }

        return (position === 'left' ? currencySymbol : '') + money + (position === 'right' ? currencySymbol : '');
    }

}
